// Copyright (c) 2022 Siemens

/**
 * @module js/oPINIPService.js
 */

import swaC from '@swac/container';
import _appCtxSvc from 'js/appCtxService';
import _ from 'lodash';

let exports = {};
var SWAC = new swaC(),
    ipUrl = "",
    ipMethodIn = "",
    ipMethodOut = "",
    swacIPComponent,
    autoRenew = false,
    clbkLogout = null,
    clbknewLanguage = null,
    clbknewTelemetry = null,
    clbkRenew = null;

//test support
if ("mockSWAC" in window) {
    SWAC = window.mockSWAC;
}
//Default creation timeout increased for OPCenter IP swac Component
SWAC.Config.TimeOuts.Create = 10000;
SWAC.Config.TimeOuts.Enabled = false;
//SWAC Container Broadcast event for a new Component Ready 
if (!window.hasOwnProperty('SwacSubscr')) {
    window.SwacSubscr = {};
    SWAC.Container.onRemoved.subscribe(function (event) {
        if (event.data.name === "swacIPComponent") {
            location.reload(true);
        }
    });
}
exports.getSwacIPComponent = function () {
    return swacIPComponent;
}
exports.setLanguage = function (lang) {
    return swacIPComponent.proxy.setLanguage(lang);
};
exports.goBack = function(){
    history.back()
}
exports.getLanguage = function () {
    return swacIPComponent.proxy.getLanguage();
};
exports.showHtml = function (fName) {
    window.open("./" + fName);
};
exports.setFederation = function(fedCode){
    if (swacIPComponent) {
        return swacIPComponent.proxy.setOptions({federation:fedCode});
    }
    return Promise.reject("swacIPService init failed");        
}
exports.init = function (IPUrl, ipMethodLogin, ipMethodLogout, logoutClbk, newTokenClbk, renewAuto, newLanguageClbk, newTelemetryClbk) { // NOSONAR
    autoRenew = renewAuto;
    ipUrl = IPUrl;
    ipMethodIn = ipMethodLogin;
    ipMethodOut = ipMethodLogout;
    if (logoutClbk) {
        clbkLogout = logoutClbk;
    }
    if (newLanguageClbk) {
        clbknewLanguage = newLanguageClbk;
    }
    if (newTelemetryClbk) {
        clbknewTelemetry = newTelemetryClbk;
    }
    if (newTokenClbk) {
        clbkRenew = newTokenClbk;
    }
    let modeSWAC = _appCtxSvc.getCtx("swacModeStart");
    if (typeof swacModeStart !== "boolean") {
        if (window.location.pathname.toLowerCase().indexOf("/swac.html") !== -1) {
            _appCtxSvc.updateCtx("swacModeStart", true);
        } else {
            var baseUrl = location.href;
            if (baseUrl.indexOf("swacMode=yes") !== -1) {
                _appCtxSvc.updateCtx("swacModeStart", true);
            } else {
                _appCtxSvc.updateCtx("swacModeStart", false);
            }
        }
        modeSWAC =  _appCtxSvc.getCtx("swacModeStart");
    }
    if (modeSWAC){
        ipUrl += "swacModeLight.html#/?swacSilentMode=yes";    
    }
    else{
    //e.g.: http://127.0.0.1:8081/ become -> http://127.0.0.1:8081/swacMode.html#/?swacSilentMode=yes // NOSONAR   
    ipUrl += "swacMode.html#/?swacSilentMode=yes";
    }
    //Component is created full screen but keeped hidden
    var component0Info = {
        name: 'swacIPComponent',
        type: '',
        source: ipUrl,
        settings: {
            left: '0px',
            top: '0px',
            width: '100%',
            height: '100%',
            flavor: 'ui'
        }
    };
    return SWAC.Container.beginCreateAndGet(component0Info).then(cmp => {
        swacIPComponent = cmp;
        if (swacIPComponent.hasOwnProperty("_internal") && swacIPComponent._internal.hasOwnProperty("iframe")) {
            let elem = swacIPComponent._internal.iframe.getIFrame();
            elem.style.zIndex = 5001;
        }
        if (autoRenew) {
            (function debounceCognitoRenew(wait, _deboundParams) {
                let callF = function () {
                    swacIPComponent.proxy.getToken({
                        authMethod: ipMethodIn
                    }).then(function (data) {}, function (reason) {
                        clbkRenew()
                    });
                };
                var userActivity = _.debounce(callF, wait, _deboundParams);
                $(document).on("click tokenrenew keydown keyup mousemove", userActivity);
            })(1000 * 60 * 5, {
                leading: true,
                maxWait: 3 * 1000 * 60 * 5
            });
        }
        //event subscriptions 
        if (clbkLogout) {
            swacIPComponent.proxy.onLogout.subscribe(clbkLogout);
        }
        if (clbkRenew) {
            swacIPComponent.proxy.onTokenChanged.subscribe(clbkRenew);
        }
        swacIPComponent.proxy.onLanguageChanged.subscribe(function (newV) {
            if (clbknewLanguage) {
                clbknewLanguage(newV.data);
            }
        });
        swacIPComponent.proxy.onTelemetryChanged.subscribe(function (newV) {
            if (clbknewTelemetry) {
                clbknewTelemetry(newV.data);
            }
        });

    });
}
exports.getEnabledFeatures = function () {
    if (swacIPComponent) {
        return swacIPComponent.proxy.getEnabledFeatures();
    }
    return Promise.reject("swacIPService getEnabledFeatures failed");
};
exports.getTennantConf = function () {
    if (swacIPComponent) {
        return swacIPComponent.proxy.getTennantConf();
    }
    return Promise.reject("swacIPService getTennantConf failed");
};
exports.setTelemetry = function(flag) {
    swacIPComponent.proxy.setTelemetry(flag);
};
exports.getTelemetry = function() {
    return swacIPComponent.proxy.getTelemetry();
};
exports.setTelemetryDPE = function(flag) {
    swacIPComponent.proxy.setTelemetryDPE(flag);
};
exports.getTelemetryDPE = function() {
    return swacIPComponent.proxy.getTelemetryDPE();
};
exports.getDisclosure = function() {
    return swacIPComponent.proxy.getDisclosure();
};
exports.setDisclosure = function ( flag ) {
    //currDisclosureFlag = flag;
    swacIPComponent.proxy.setDisclosure(flag);
};
exports.getToken = function () {
    if (swacIPComponent) {
        return swacIPComponent.proxy.getToken({
            authMethod: ipMethodIn
        })
    }
    return Promise.reject("swacIPService init failed");
};
exports.login = function () {
    if (swacIPComponent) {
        const retPromise = swacIPComponent.proxy.showAuthForm({
            authMethod: ipMethodIn
        }).then(function (data) {
            swacIPComponent.beginShow(false);
            return data;
        }, function (reason) {
            swacIPComponent.beginShow(false);
            throw (reason);
        });
        swacIPComponent.beginShow(true);
        return retPromise;
    }
    return Promise.reject("swacIPService init failed");
};
exports.logout = function () {
    var resolveF;
    var rejectF;
    var myPromise = new Promise( function( resolve, reject ) {
        resolveF = resolve;
        rejectF = reject;
    } );
    if ( swacIPComponent ) {
        return swacIPComponent.proxy.clearToken( {
            authMethod: ipMethodOut
        } ).then( function() {
            resolveF( 'Logout successful' );
        }, function( reason ) {
            rejectF( reason );
        } );
    }
    return myPromise;
};
exports.getTokenMode = function () {
    if (swacIPComponent) {
        return swacIPComponent.proxy.getTokenMode();
    }
    return Promise.reject("swacIPService init failed");
};

exports.changePSW = function (authMethod) {
    if (swacIPComponent) {
        return new Promise((resolve, reject) => {
            swacIPComponent.proxy.showAuthForm({
                authMethod: authMethod
            }).then(function (data) {
                swacIPComponent.beginShow(false);
                resolve(data);
            }, function (reason) {
                swacIPComponent.beginShow(false);
                reject(reason);
            });
            swacIPComponent.beginShow(true);
        } );
    }
    return Promise.reject("swacIPService init failed");
};
exports.showExternalHtml = function (ulrToOpen) {
    window.open(ulrToOpen);
};
exports.setObjProps = function (conf) {
    if (conf.length) {
        return {
            data: conf.map(exports.setObjProp)
        };
    }
    return {
        data: []
    }
};

function convertValue(conf) {
    var v = conf.value;
    if ("type" in conf) {
        if (conf.type === "INTEGER") {
            v = parseInt(v, 10);
        } else if (conf.type === "BOOLEAN") {
            if (typeof v === 'string') {
                v = v === 'true';
            } else {
                v = Boolean(v);
            }
        }
    }
    return v;
}
exports.setObjProp = function (conf) {
    var v = convertValue(conf);

    if ("array" in conf && Array.isArray(conf.array)) {
        v = conf.array[v];
    } else if ("dictionary" in conf && Array.isArray(conf.dictionary.values)) {
        var keyValuePair = conf.dictionary.values.filter(function (val) {
            return val[conf.dictionary.keyName] === v;
        }).pop();
        if (typeof keyValuePair !== 'undefined' && conf.dictionary.keyName in keyValuePair) {
            v = keyValuePair[conf.dictionary.valueName];
        } else {
            v = null;
        }
    }
    return v;
};

exports.getNotifications = function() {
    if ( swacIPComponent ) {
        return swacIPComponent.proxy.getNotification();
    }
    return Promise.reject("swacIPService init failed");    
};
exports.setNotifications = function( notifications ) {
    if ( swacIPComponent ) {
        return swacIPComponent.proxy.setNotification( notifications );
    }
    return Promise.reject("swacIPService init failed");    
};

export default new Proxy(exports, {
    get(target, prop) {
        if (typeof target[prop] === 'function') {
            return new Proxy(target[prop], {
                apply: (target, thisArg, argumentsList) => {
                    console.debug("####oPINIPService method call: " + prop, argumentsList)
                    return Reflect.apply(target, thisArg, argumentsList);
                }
            });
        } else {
            return Reflect.get(target, prop);
        }
    }
} );
